//把mutations中的方法名称抽离到，可以统一修改mutatios和actions时候写的参数方法（一致）

export const SET_USER = "setuser"
export const SET_GOODSINFO = "setgoodsinfo"